import { useEffect, useState, useRef } from "react";

// Cycle of fun callouts that pop off the +1 button on every capture. We
// bias toward "+1" so the user never loses the "I added something" mental
// model, but sprinkle in playful WOW-vibes ~30% of the time. (User ask
// 2026-05-04 "add some cool stuff across the five below theme".)
const POP_TEXTS = [
  "+1", "+1", "+1", "+1", "+1", "+1", "+1",
  "WOW!", "BOOM!", "NICE!", "YES!", "🔥", "💥", "⚡",
];
const COLORS = [
  "#FACC15", // FB yellow
  "#0066FF", // FB blue
  "#EC4899", // pink
  "#16A34A", // green
  "#FACC15",
  "#0066FF",
];

let idCounter = 0;

/**
 * Spawns short-lived floating "+1" / "WOW!" pops on every capture. The
 * parent calls `triggerPop()` (via ref) on every +1 tap; we render and
 * auto-cleanup each pop after 1.1s so the DOM never accumulates dead
 * nodes even on a 100-tap shift.
 */
export default function FloatingPops({ instanceRef }) {
  const [pops, setPops] = useState([]);

  useEffect(() => {
    if (!instanceRef) return;
    instanceRef.current = {
      trigger: () => {
        const id = ++idCounter;
        const text = POP_TEXTS[Math.floor(Math.random() * POP_TEXTS.length)];
        const color = COLORS[Math.floor(Math.random() * COLORS.length)];
        // Horizontal jitter so back-to-back pops don't stack on the same
        // pixel column. ±18px feels organic without scattering off-button.
        const dx = Math.round((Math.random() - 0.5) * 36);
        setPops((prev) => [...prev, { id, text, color, dx }]);
        // GC after the animation finishes so React doesn't keep a dead list.
        setTimeout(() => {
          setPops((prev) => prev.filter((p) => p.id !== id));
        }, 1150);
      },
    };
    return () => { instanceRef.current = null; };
  }, [instanceRef]);

  return (
    <div className="pointer-events-none absolute inset-0 overflow-visible" aria-hidden data-testid="floating-pops">
      {pops.map((p) => (
        <span
          key={p.id}
          className="fb-pop-rise absolute font-black select-none"
          style={{
            left: `calc(50% + ${p.dx}px)`,
            top: 0,
            color: p.color,
            // Outline so the text reads against any background tint.
            textShadow: "0 0 2px rgba(0,0,0,0.35), 0 2px 8px rgba(0,0,0,0.25)",
            WebkitTextStroke: "1px rgba(0,0,0,0.18)",
            fontSize: p.text.length <= 2 ? "2.6rem" : "1.7rem",
            fontFamily: "'Five Below Gothic', Chivo, sans-serif",
          }}
        >
          {p.text}
        </span>
      ))}
    </div>
  );
}
